import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../store/Application/ApplicationReducer';
import { InitApplicationConfig } from '../store/Application/ApplicationActions';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ServerMetadataService {
  public static openLoginAfterLoad: boolean;

  constructor(
    private http: HttpClient,
    private router: Router,
    private readonly applicationStore: Store<ApplicationState>,
  ) {}

  initServerMetadata(): Promise<void> {
    if (location.href.includes('login')) {
      ServerMetadataService.openLoginAfterLoad = true;
    }
    return new Promise((resolve, reject) => {
      this.http
        .get('/rl/api/application/preload')
        .toPromise()
        .then((resp: any) => {
          localStorage.setItem('currentUser', JSON.stringify(resp.user));
          this.applicationStore.dispatch(new InitApplicationConfig(resp));
          if (!resp.user) {
            localStorage.removeItem('currentUser');
            this.router.navigate(['login']);
          }
          resolve();
        })
        .catch((err) => {
          localStorage.removeItem('currentUser');
          this.router.navigate(['login']);
          resolve();
        });
    });
  }
}
